<template>
	<Panel :title="title" icon="check-square" url="/mis-quinielas">
		<p class="panel-block" v-show="quinielas.length == 0">No hay Quinielas en este momento..</p>
		<transition-group name="card" mode="out-in">
			<router-link :to="'/ver-quiniela/' + quiniela.id" v-for="quiniela in quinielas" :key="quiniela.id+'-'+quiniela.estado" class="panel-block is-block">

				<div class="level is-mobile" :class="classEstadoText(quiniela.estado)">
					<div class="level-left">
						<div class="level-item">
							<span class="icon" title="Quiniela en juego" v-if="quiniela.estado == 2">
								<font-awesome-icon icon="futbol" />
							</span>
							<span>{{ quiniela.nombre }}</span>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">
							<span v-if="quiniela.tipo == 1" class="tag" :class="classEstado(quiniela.estado)">
								<span class="icon"><font-awesome-icon icon="users" /></span>
								<span>{{ quiniela.jugadores_count }}</span>
							</span>
						</div>
					</div>
				</div>
			</router-link>

			<router-link v-if="mis_quinielas.length > 8" key="ver-todas" to="/mis-quinielas" class="panel-block">
				<p class="link">ver todas mis quinielas...</p>
			</router-link>
		</transition-group>
	</Panel>
</template>

<script>
	import { mapState } from 'vuex'
	import Panel from '@/components/Panel'
	import quiniMixin from '@/mixins/quiniMixin'

	export default {
		components: { Panel },
		mixins: [quiniMixin],
		props: {
			title: {
				type: String,
				required: true,
			}
		},
		name: 'UltimasQuinielas',

		data() {
			return {
				
			};
		},
		computed: {
			quinielas(){
				return this.mis_quinielas.slice(0,8)
			},
			...mapState('quinielas',['mis_quinielas'])
		},
		created(){
			if (this.mis_quinielas.length == 0) {
				this.$store.dispatch('quinielas/fetchMisQuinielas')
			}
		}
	};
</script>

<style lang="css" scoped>
.link{text-decoration: underline;cursor: hand;}
</style>
